import { render, staticRenderFns } from "./dstr-sign-verify.vue?vue&type=template&id=5313658f&scoped=true"
import script from "./dstr-sign-verify.vue?vue&type=script&lang=js"
export * from "./dstr-sign-verify.vue?vue&type=script&lang=js"
import style0 from "./dstr-sign-verify.vue?vue&type=style&index=0&id=5313658f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313658f",
  null
  
)

export default component.exports